import clsx from 'clsx'
import React, {FC} from 'react'
import {KTSVG, toAbsoluteUrl, getDefaultProfileImage} from '../../../helpers'
import {HeaderNotificationsMenu, HeaderUserMenu, QuickLinks, Search} from '../../../partials'
import {useLayout} from '../../core'
import useNotifications from '../../../../hooks/useNotifications'
import useAuth from '../../../../hooks/useAuth'
import useGlobals from '../../../../hooks/useGlobals'
import {useConnectedUsersCount} from '../../../../hooks/useConnectedUsersCount'
import {useAdminStatus} from '../../../../hooks/useAdminStatus'
import {ReactSelectInput} from '../../../partials/controls'
import {FormattedMessage} from 'react-intl'
import QRCodeScanner from './QRCode'
import {LanguageSwitcher, languages} from '../../../partials/layout/header-menus/LanguageSwitcher'
import {useLang} from '../../../i18n/Metronici18n'
const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px',
  toolbarButtonIconSizeClass = 'svg-icon-1'

const Topbar: FC = () => {
  const {config} = useLayout()

  const {fetchNotifications, unreadNotificationCount} = useNotifications()
  const {me} = useAuth()
  const isAdmin = String(me?.role) === '2'
  const {count: connectedUsersCount} = useConnectedUsersCount(!!isAdmin)
  const {online: adminOnline} = useAdminStatus(!!me && !isAdmin)
  const lang = useLang()
  const currentLanguage = languages.find((x) => x.lang === lang)
  React.useEffect(() => {
    /*let interval: any
    if (me) {
      const request = () => {
        fetchNotifications({recipient: me._id!})
      }
      request()
      interval = setInterval(request, 10000)
    }
    return () => {
      if (interval) {
        clearInterval(interval)
      }
    }*/
  }, [me])

  const {kid, onKidUpdate, actifQrCodeCamera, activateQrCodeCamera, desactivateQrCodeCamera} =
    useGlobals()

  const getKidValue = (value: any) => {
    if (me && me.kids) {
      if (!value || value === '') return null
      let user = me.kids.find((user) => user._id == value._id)
      return user ? {label: `${user.firstName} ${user.lastName}`, value: user._id} : null
    }
    return null
  }
  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>
      {me && me.role === '5' ? (
        <div className='d-flex align-items-center' style={{minWidth: '140px', maxWidth: '180px'}}>
          <div style={{transform: 'scale(0.85)', transformOrigin: 'left center', width: '100%'}}>
            <ReactSelectInput
              placeholder={<FormattedMessage id='SELECT.PLACEHOLDER.KID' />}
              value={getKidValue(kid)}
              onChange={(user) => {
                if (user) {
                  onKidUpdate(user)
                } else {
                  onKidUpdate(undefined)
                }
              }}
              isClearable={true}
              options={
                me.kids
                  ? me.kids.map((kid) => ({
                      ...kid,
                      label: `${kid.firstName} ${kid.lastName}`,
                      value: kid._id!,
                    }))
                  : []
              }
            />
          </div>
        </div>
      ) : (
        <></>
      )}
      {me && (me.role === '2' || me.role === '3') ? (
        <>
          <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
            {/* begin::Menu- wrapper */}
            <div
              className={clsx(
                'btn btn-icon btn-active-light-primary btn-custom',
                toolbarButtonHeightClass
              )}
              onClick={() => {
                if (!actifQrCodeCamera) {
                  activateQrCodeCamera()
                } else {
                  desactivateQrCodeCamera()
                }
              }}
            >
              <KTSVG
                path='media/icons/duotune/electronics/elc003.svg'
                className={toolbarButtonIconSizeClass}
              />
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
      {isAdmin && connectedUsersCount !== null && (
        <div
          className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
          title='Users currently connected to the platform'
        >
          <span className='badge badge-light-primary fs-8 px-3 py-2'>
            <span className='bullet bullet-dot bg-success me-2' />
            {connectedUsersCount} {connectedUsersCount === 1 ? 'user' : 'users'} online
          </span>
        </div>
      )}
      {me && !isAdmin && adminOnline === true && (
        <div
          className={clsx('d-flex align-items-center position-relative', toolbarButtonMarginClass)}
          title='Admin El Farabi is online'
        >
          <div
            className={clsx(
              'btn btn-icon btn-active-light-primary btn-custom position-relative',
              toolbarButtonHeightClass
            )}
            style={{
              color: '#10b981',
            }}
          >
            <KTSVG
              path='/media/icons/duotune/communication/com001.svg'
              className={toolbarButtonIconSizeClass}
            />
            {/* Status indicator dot */}
            <span
              className='position-absolute top-0 start-100 translate-middle badge badge-circle bg-success'
              style={{
                width: '10px',
                height: '10px',
                minWidth: '10px',
                minHeight: '10px',
                border: '2px solid white',
                marginLeft: '-4px',
                marginTop: '2px',
              }}
            />
          </div>
        </div>
      )}
      <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
        {/* begin::Menu- wrapper */}
        <div
          className={clsx(
            'btn btn-icon btn-active-light-primary btn-custom position-relative',
            toolbarButtonHeightClass
          )}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          <KTSVG
            path='/media/icons/duotune/general/gen007.svg'
            className={toolbarButtonIconSizeClass}
          />
          {unreadNotificationCount > 0 && (
            <span
              className='position-absolute top-0 start-100 translate-middle badge badge-circle badge-primary badge-sm min-w-18px min-h-18px fs-9 fw-bolder d-flex align-items-center justify-content-center'
              style={{marginLeft: '-2px', marginTop: '2px'}}
            >
              {unreadNotificationCount > 99 ? '99+' : unreadNotificationCount}
            </span>
          )}
        </div>
        <HeaderNotificationsMenu />
        {/* end::Menu wrapper */}
      </div>
      {/* begin::Language Switcher */}
      <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
        {/* begin::Menu wrapper */}
        <div
          className={clsx(
            'btn btn-icon btn-active-light-primary btn-custom position-relative',
            toolbarButtonHeightClass
          )}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
          title={currentLanguage?.name || 'Language'}
        >
          <img 
            src={currentLanguage?.flag} 
            alt={currentLanguage?.name || 'Language'} 
            className='w-20px h-20px rounded-1'
          />
        </div>
        <LanguageSwitcher />
        {/* end::Menu wrapper */}
      </div>
      {/* end::Language Switcher */}
      {/* begin::User */}
      <div
        className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
        id='kt_header_user_menu_toggle'
      >
        {/* begin::Toggle */}
        <div
          className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          {(() => {
            const defaultProfileImage = getDefaultProfileImage(me?.gender)
            const userImage = me?.picture || me?.avatar
            const profileImage = userImage
              ? (userImage.startsWith('http') ? userImage : toAbsoluteUrl(`/media/${userImage}`))
              : defaultProfileImage
            return (
              <img 
                src={profileImage} 
                alt={`${me?.firstName} ${me?.lastName}`}
                onError={(e) => {
                  // Fallback to direct path if toAbsoluteUrl fails
                  const target = e.target as HTMLImageElement
                  if (!target.src.includes('/media/logos/')) {
                    const gender = me?.gender?.toLowerCase() || ''
                    const fallbackImage = gender === 'femme' || gender === 'girl' || gender === 'female' || gender === 'f' || gender === 'fille'
                      ? '/media/logos/profile1.png'
                      : '/media/logos/profile2.jpg'
                    target.src = fallbackImage
                  }
                }}
              />
            )
          })()}
        </div>
        <HeaderUserMenu />
        {/* end::Toggle */}
      </div>
      {/* end::User */}
      {/* begin::Aside Toggler */}
    </div>
  )
}

export {Topbar}
